import AcxDialog from "components/UI/Dialog/AcxDialog";
import React from "react";
import { SignalsShareDashboard } from "./ShareDialog/SignalsShareDashboard";
import { useCurrentDashboard } from "../../useCurrentDashboard";

// Dialog component for sharing the dashboard. This dialog has all of its content inside the ShareDialog folder
export const DashboardSharingDialog = ({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const currentDashboard = useCurrentDashboard();

    if (!currentDashboard) {
        return null;
    }

    return (
        <AcxDialog
            id="share"
            title={"Share Dashboard"}
            subTitle={
                "Share this dashboard with your organization or specific people."
            }
            dialogContentChildren={<SignalsShareDashboard />}
            isOpen={open}
            onClose={() => setOpen(false)}
            disableEnforceFocus
            hideCancelButton
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "675px", // Set your width here
                    },
                },
            }}
        />
    );
};
